import React from 'react';

export class NewAppLoading extends React.Component {

	displayLoadingBlank(className = "") {
		return <span className={`loading-span ${className}`}/>
	}

	render() {
		return (
			<section className="new-app-name-platform">
				<div className="saved-app-name-and-platform container">
					<div className="row info-section">
						<div className="new-app-icon col-3">
							<img src="/images/placeholder-image.png" width="200" height="200" alt="App icon placeholder" />
						</div>
						<div className="new-app-info col-9">
							<h1>{this.displayLoadingBlank()}</h1>
							<div className="row">
								<div className="saved-app-listing-info col-4">
									<div className={`saved-app-listing-info-row`}><span className={this.editHoverClass}>Platform: <strong>{this.displayLoadingBlank("quarter")}</strong></span></div>
									<div className={`saved-app-listing-info-row`}><span className={this.editHoverClass}>Listing Type: <strong>{this.displayLoadingBlank("quarter")}</strong></span></div>
								</div>
								<div className="saved-app-listing-info col-8">
									<div className={`saved-app-listing-info-row`}><span className={this.editHoverClass}>URL: <strong>{this.displayLoadingBlank("quarter")}</strong></span></div>
									<div className={`saved-app-listing-info-row`}><span className={this.editHoverClass}>Version: <strong>{this.displayLoadingBlank("quarter")}</strong></span></div>
								</div>
							</div>
						</div>
					</div>
					<div className="row save-section">
						<div className="col-7 offset-3">
							<div className="saved-app-status">DRAFT</div>
							<div className="saved-app-time-delete">
								<span>Last Saved: </span>
								<span className="saved-app-time">{this.displayLoadingBlank("quarter")}</span>
								<span className="saved-app-pipe"> &#124; </span>
								<span className="saved-app-time">{this.displayLoadingBlank("quarter")}</span>
							</div>
						</div>
					</div>
				</div>
			</section>
		)
	}
}